module.exports = __webpack_public_path__ + "static/media/people-carry.d3275882.svg";